import {useEffect} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {useSelector} from 'react-redux';
import backIcon from 'images/back.png';
import {NavTabsEnum} from 'utils/constants';
import {makeSelectTabOperations} from 'redux/store/auth';
import styles from '../../assetClassOverview.module.scss';
import {MutualFundsInventoryPrediction} from './MutualFundsInventoryPrediction';
import {supportsInventoryPrediction} from 'pages/AssetManagement/modules/instrumentKeys';
import {assetClassLabel} from 'pages/AssetManagement/modules/instrumentKeys';

export const MutualFundInventoryPredictionPage = () => {
  const {key} = useParams();
  const navigate = useNavigate();

  const pageOperations = useSelector(state =>
    makeSelectTabOperations(state, NavTabsEnum.assetClasses),
  );

  // The tab is hidden elsewhere, but the URL is still reachable by hand or
  // from a stale bookmark, and the page would render fund forecasts under
  // another asset class's heading.
  useEffect(() => {
    if (!supportsInventoryPrediction(key)) {
      navigate(`/dashboard/asset-management/class/${key}/instruments`, {
        replace: true,
      });
    }
  }, [key]);

  if (!supportsInventoryPrediction(key)) return null;

  return (
    <div>
      <div className={styles.nav}>
        <div className={styles.topNav}>
          <img
            onClick={() => navigate(`/dashboard/asset-management/classes`)}
            src={backIcon}
            alt=""
          />
          <h1>{assetClassLabel(key)} financial instruments</h1>
        </div>
      </div>
      <div className={styles['details-toggler']}>
        <span
          onClick={() =>
            navigate(`/dashboard/asset-management/class/${key}/instruments`)
          }>
          Instruments
        </span>
        <span className={styles['active-toggle']}>Inventory Prediction</span>
      </div>
      <MutualFundsInventoryPrediction
        canRun={pageOperations?.update}
        assetClassKey={key}
      />
    </div>
  );
};
